export const testimonialConstants = {
	Testimonial_GetByFilter_Request : "TESTIMONIAL_GET_ALL_STARTED",
	Testimonial_GetByFilter_Success : "TESTIMONIAL_GET_ALL_COMPLETED",
	Testimonial_GetByFilter_Failure: "TESTIMONIAL_GET_ALL_FAILED",

	TestimonialDetailRequest: "TESTIMONIAL_GET_DETAIL_STARTED",
	TestimonialDetailSuccess: "TESTIMONIAL_GET_DETAIL_COMPLETED",
	TestimonialDetailFailure: "TESTIMONIAL_GET_DETAIL_FAILED",

	TestimonialStatusUpdateRequest: "TESTIMONIAL_STATUS_UPDATE_STARTED",
	TestimonialStatusUpdateSuccess: "TESTIMONIAL_STATUS_UPDATE_COMPLETED",
	TestimonialStatusUpdateFailure: "TESTIMONIAL_STATUS_UPDATE_FAILED",
	
	TestimonialVideoStatusUpdateRequest: "TESTIMONIAL_VIDEO_STATUS_UPDATE_STARTED",
	TestimonialVideoStatusUpdateSuccess: "TESTIMONIAL_VIDEO_STATUS_UPDATE_COMPLETED",
	TestimonialVideoStatusUpdateFailure: "TESTIMONIAL_VIDEO_STATUS_UPDATE_FAILED",
    
}